import Dialog from "../../atoms/dialog";
import { useState } from 'react'
import DeleteEventType from "../messages/DeleteEventType";

const DeleteEventTypeAlert = (props) => {

    const { eventTypeId, onClose, onCompletion } = props;
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
        onClose()
    }

    return (
        <Dialog
            title={"Delete"}
            open={true}
            handleClose={handleClose}
        >
            <DeleteEventType eventTypeId={eventTypeId} onClose={handleClose} onCompletion={onCompletion} />
        </Dialog >
    )
}

export default DeleteEventTypeAlert;